/* eslint-disable */
export default async function externalComponent(url):Promise<any> {
    const name = url.split('/').reverse()[0].match(/^(.*?)\.umd/)[1];

    if (window[name]) return window[name];

    window[name] = await new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.async = true;
        script.addEventListener('load', () => {
            console.log("loaded");
            console.log(window[name]);
            resolve(window[name]);
        });
        script.addEventListener('error', () => {
            console.log("error");
            reject(new Error(`Error loading ${url}`));
        });
        script.src = url;
        document.head.appendChild(script);
    });
    return window[name];
}
